import { render, staticRenderFns } from "./PlanChange.vue?vue&type=template&id=57aa98a0"
import script from "./PlanChange.vue?vue&type=script&lang=js"
export * from "./PlanChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports